// extracted by mini-css-extract-plugin
module.exports = {"couponList":"CouponList_couponList__sd41j"};